import {
  CentrosLaboBody,
  CentrosLaboContainer,
  CentrosLaboHeader,
} from "./localStyle";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import FiltroCheck from "./FiltroCheck/FiltroCheck";
import {
  hideToaster,
  showToaster,
} from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import BarraAzul from "_+_Portal/_-_Autocheckin/components/genericos/BarraAzul/BarraAzul";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "_+_Portal/context/Actions/laboGrupo/laboGrupo";
import Layout from "_+_Portal/components/Genericos/Layout/Layout";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";

const CentrosLabo = () => {
  //#region --------- context ---------------
  const { toasterDispatch } = useContext(GlobalContext);
  const {
    nuevoTurnoState,
    laboGrupoDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
  } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [loading, setLoading] = useState(true);
  const [centros, setCentros] = useState(false);
  const history = useHistory();
  const pacienteSeleccionado = nuevoTurnoState.nuevoTurno.familiar?.paciente;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const onClickAvanzar = (arrayCentros) => {
    if (arrayCentros.length > 0) {
      setLoading(true);
      // setCentrosLaboSeleccionados(arrayCentros)(centroDispatch);
      laboGrupo((isCorrect, data) =>
        nextStepGrupoEstudio(isCorrect, data, arrayCentros),
      )(laboGrupoDispatch);
    } else {
      showToaster(
        {
          texto: "Debe seleccionar al menos un Centro Médico",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const nextStepGrupoEstudio = (isCorrect, data, arrayCentros) => {
    if (isCorrect) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          arrayCentros,
        },
      })(turnosDisponiblesDispatch);
      setLoading(false);
      hideToaster()(toasterDispatch);
      history.push("/seleccionLabo");
    }
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    setLoading(true);
    wsGetLaboCentros((isCorrect, data) => {
      if (isCorrect) {
        setCentros(data);
      } else {
        showToaster(
          {
            texto: "Error al cargar centros médicos",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
      setLoading(false);
    })(laboGrupoDispatch);
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <Layout>
        <CentrosLaboContainer>
          <BarraAzul
            title={"Laboratorio"}
            backBtn={true}
            pacienteSeleccionado={pacienteSeleccionado?.nombre}
          />
          <CentrosLaboHeader>
            <span>Seleccione el o los centros donde desea buscar turnos</span>
          </CentrosLaboHeader>
          <CentrosLaboBody>
            {!loading && (
              <FiltroCheck
                values={["Todos"]}
                elementos={centros}
                defaultValue={"descripcion"}
                labelValue={"ubicacion"}
                onClick={onClickAvanzar}
              />
            )}
          </CentrosLaboBody>
        </CentrosLaboContainer>
      </Layout>
    </>
  );
};

export default CentrosLabo;
